import React from 'react'
import PropTypes from 'prop-types'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Text,
    ModalCloseButton,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

const WhereToBuyModal = ({isOpen, onClose}) => {
    const intl = useIntl()
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalBody>
                    <Text>
                        {intl.formatMessage({
                            id: 'global.where-to-buy.modal',
                            defaultMessage:
                                'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                        })}
                    </Text>
                </ModalBody>
                <ModalCloseButton />
            </ModalContent>
        </Modal>
    )
}
WhereToBuyModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default WhereToBuyModal
